import axios from "axios";
import Cookies from 'universal-cookie';

const cookies = new Cookies();

// new user add to db via axios
export default function addNewUser(data){
  return axios.post(`${process.env.REACT_APP_API_URL}/signup/`, data, {headers: {
    'Content-Type': 'application/json',
    'Accept': '*/*',
    'Access-Control-Allow-Origin': '*',
    'Authorization' : 'Bearer '+ cookies.get('access')
  }})
}